import type { KehrblattFrameMember } from "../../../../../../../../../api/kehrblatt/organization-frame"
import { userDisplayName } from "@kontextwerk/control-web-frame/shared/logic/user-presentation"
import { buildWorkingHoursByUser } from "../../../../../../../../../_shared/_logic/working-hours-view"
import { filterSelectableOrganizationUsers } from "../../../../../../../_shared/_logic/organization-users"
import type {
  EmployeeOption,
  WorkingHoursByUser,
} from "../../../../../../../../../_shared/_logic/form-state"

export type BatchPlanningEmployeeContext = {
  employees: EmployeeOption[]
  workingHoursByUser: WorkingHoursByUser
  allEmployeeIds: string[]
}

export const buildBatchPlanningEmployeeContext = (
  users: KehrblattFrameMember[] | null | undefined,
  allowedEmployeeIds: string[] | null | undefined,
): BatchPlanningEmployeeContext => {
  const scopedUsers = filterSelectableOrganizationUsers(users ?? [], allowedEmployeeIds)

  return {
    employees: scopedUsers.map((user) => ({
      id: user.id,
      label: userDisplayName(user) || "Unbekannt",
    })),
    workingHoursByUser: buildWorkingHoursByUser(scopedUsers),
    allEmployeeIds: scopedUsers.map((user) => user.id).filter(Boolean),
  }
}
